export default __webpack_public_path__ + "static/media/Inter-SemiBold.7385053d.woff2";